import { render, staticRenderFns } from "./ManagePayout.vue?vue&type=template&id=bd2986b4&scoped=true"
import script from "./ManagePayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ManagePayout.vue?vue&type=style&index=0&id=bd2986b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2986b4",
  null
  
)

export default component.exports